import { ProjectDto } from '@/core';

export const validateEpicGroupsTab = (projectData: ProjectDto) => {
  return !projectData.epicGroups.some((epicGroup) => !epicGroup.epics.length);
};
